import React from 'react';

import NavigationBar from '../components/blocks/navigation-bar'; // Import NavigationBar component
import Header from '../components/blocks/header'; // Import Header component

import { useNavigate, Outlet } from 'react-router-dom'; // Hook for navigation

import {
    HomeOutlined,
    AdminPanelSettings,
    SettingsSuggest,
    Apps
} from '@mui/icons-material'; // Import Material UI icons

import { useTitle } from '../context/header-context'; // Import the hook to get the title
import { useAuth } from '../context/auth-context';

/**
 * ClassicLayout Component
 * 
 * This component serves as a layout wrapper for pages with a header, 
 * children content, and a navigation bar.
 *
 * @param {Object} props - The properties for the component.
 * @param {ReactNode} props.children - The child components to be rendered within the layout.
 */
const ClassicLayout = () => {
    const navigate = useNavigate(); // Hook to get the navigate function

    const {currentUser} = useAuth(); // Get the current user from the auth context

    const { title } = useTitle(); // Get the title from the context

    /**
     * hasAdminAccess
     * Function to check if the current user has admin access.
     * It checks if the user has the 'ROLE_ADMIN_INTERFACE' role.
     * @returns {boolean} - Returns true if the user has admin access, false otherwise
     */
    function hasAdminAccess() {
        return (
            Array.isArray(currentUser?.roles) &&
            currentUser.roles.some(r => r.role === 'ROLE_ADMIN_INTERFACE')
        );
    }

    // Navigation items for the navigation bar
    const items = [
        {
            name: 'Accueil', // Navigation item name
            icon: <HomeOutlined />, // Icon for home
            action: () => navigate('/'), // Navigation action for home
        },
        {
            name: 'Galerie', // Navigation item name
            icon: <Apps />, // Icon for gallery
            action: () => navigate('/internal-gallery'), // Log for search action
        },
        {
            name: 'Paramètres', // Navigation item name
            icon: <SettingsSuggest />, // Icon for settings
            action: () => navigate('/settings'), // Navigation action for settings
        },
    ];

    // Add admin panel item if the user has admin access
    if (hasAdminAccess()) {
        items.push({
            name: 'Admin',
            icon: <AdminPanelSettings />,
            action: () => navigate('/admin'),
        });
    }   

    // Render the ClassicLayout with the header, content, and navigation bar
    return (
        <div className='app-container'>

            {/* Header with title */}
            <Header title={title} /> {/* Pass the title to the Header */} 

            {/* Content with outlet */}
            <div className='app-content' style={{ borderColor: 'var(--pastel-primary-color)' }}>
                <Outlet />
            </div>

            {/* Navigation bar */}
            <NavigationBar items={items} />
        </div>
    );
};

export default ClassicLayout; // Export the ClassicLayout component
